import React from "react";
import TripRateAnalysis from "./TripRateAnalysis";
import VendorComingSoon from "./VendorComingSoon";
import { isVendorActive, isVendorComingSoon } from "./vendorData";

const RateAnalysisVendorPage = ({ vendor }) => {
  if (isVendorComingSoon(vendor)) {
    return <VendorComingSoon vendor={vendor} />;
  }

  if (isVendorActive(vendor) && vendor.slug === "trip.com") {
    return <TripRateAnalysis vendor={vendor} />;
  }

  return <VendorComingSoon vendor={vendor} />;
};

export default RateAnalysisVendorPage;
